import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { forwardRef, createElement } from 'react';
import cn from 'classnames';
import { useToggle } from './useToggle.js';

var _excluded = ["className", "style", "text"];
var Toggle = /*#__PURE__*/forwardRef(function Toggle(props, ref) {
  var className = props.className,
      style = props.style,
      text = props.text,
      otherProps = _objectWithoutPropertiesLoose(props, _excluded);

  var _useToggle = useToggle(otherProps, ref),
      input = _useToggle.input;

  return createElement("span", {
    className: cn('flex items-center font-normal h-8', className),
    style: style
  }, createElement("span", {
    className: "yt-toggle"
  }, createElement("input", Object.assign({}, input)), createElement("span", {
    className: "yt-checkmark"
  }, createElement("span", {
    className: "yt-toggle__switch"
  }))), text && createElement("span", {
    className: "cursor-pointer ml-2 text-sm"
  }, text));
});

export { Toggle };
//# sourceMappingURL=Toggle.js.map
